//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {getPartyDetail} from '@/api/news/index';
export default {

  data() {
    return {
      partyId:'',
      info:{}
    };
  },

  methods: {
    get_party_detail(){
      let params = {partyId:this.partyId}
      getPartyDetail(params).then((res) => {
        this.info = res.data;
      })
    },
  },
  mounted () {
    if (typeof(this.$route.query.partyId) == "undefined" || this.$route.query.partyId == ""){
      this.$router.push("/error/201");
    }else{
      this.partyId = this.$route.query.partyId;
      this.get_party_detail();
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/party/party_details.vue